export enum FindIndex { NO_EXISTE = -1 }
